function setupBlogPage() {  
  if (jQuery('section > div').hasClass('blogs')) {
    loadMoreblogs();
    setupSearchBox();
    setupBlogCheckMarks();
    setupblogInfiniteScroll();
  }
}

var blogPage = 0;
var blogLastPage = false;
var blogInfiniteInprogress = false;
var blogLoadMoreTimeout = null;
var blogFilterTag = '';
var blogFilterSearch = '';

function setupblogInfiniteScroll() {
  jQuery(window).scroll(function() {
    if (jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() - 100) {
      loadMoreblogs();
    }
  });
}

function loadMoreblogs() {
  
  if (blogInfiniteInprogress)
    return;
  
  if (blogLastPage)
    return;
  
  blogLoadMoreTimeout = setTimeout(function(){ 
    blogInfiniteInprogress = true;
    blogPage++;
    var parameters = '&tag=' + blogFilterTag + '&search=' + blogFilterSearch;
    jQuery.get('/blog/list?limit=9&page=' + blogPage + parameters, function(data) {
      if (data.length > 0 ) {
        jQuery.each(data, function(index, blog) {   
          appendBlogToList(blog);
        });        
        blogInfiniteInprogress = false;
      } else {
        blogLastPage = true;
        blogInfiniteInprogress = false;
      }
    });
  }, 200);
}

function appendBlogToList(blog)
{
  var template = jQuery('#templates #blog').clone();            
  var title = blog.title;
  var excerpt = blog.excerpt;
  
  if (title.length > 60)
    title = title.substring(0, 60) + '...';
  
  if (excerpt.length > 200)
    excerpt = excerpt.substring(0, 200) + '...';
  
  jQuery(template).find('h2').html(title);
  jQuery(template).find('p').html(excerpt);  
  jQuery(template).find('a img').attr('src', '/img/blogs/' + blog.uuid + '.jpg'); 
  jQuery(template).find('a').attr('href', '/blog/' + blog.url); 
  
  jQuery('.blogs .grid').append(template);
}

function getBlogFilterValues()
{
  blogFilterTag = '';
  jQuery('.blogs .filter .tags > li a.checked').each(function (index) {
    var id = jQuery(this).attr('id');
    if (id > 0)
      blogFilterTag += id + ',';
  }); 
  blogFilterTag = blogFilterTag.substring(0, blogFilterTag.length - 1)  
}


function blogSearch()
{
  getBlogFilterValues();
  
  blogPage = 1;
  blogLastPage = false;
  var parameters = '&tag=' + blogFilterTag + '&search=' + blogFilterSearch;
  
  jQuery.get('/blog/list?' + parameters, function(data) {
    jQuery('.blogs .grid').html('');

    if (data.length > 0 ) {      
      jQuery.each(data, function(index, blog_post) {   
        appendBlogToList(blog_post);
      });
    }
  });
}

function setupSearchBox() {
  jQuery('.blogs #search').on('submit', function(e) {
    e.preventDefault();
    blogFilterSearch = jQuery('#search-text', jQuery(this)).val();
    blogSearch();
  });
}

function setupBlogCheckMarks() {
  jQuery('.blogs .check-mark').unbind().click(function(e) {
    e.preventDefault();
    
    if (jQuery(this).hasClass('checked'))
      jQuery(this).removeClass('checked');      
    else
      jQuery(this).addClass('checked');
    
    blogFilter();
  });
}

function blogFilter()
{
  getBlogFilterValues();
  
  blogPage = 1;
  blogLastPage = false;
  var parameters = '&tag=' + blogFilterTag + '&search=' + blogFilterSearch;

  jQuery.get('/blog/list?' + parameters, function(data) {
    jQuery('.blogs .grid').html('');
    if (data.length > 0 ) {      
      jQuery.each(data, function(index, blog) {
        appendBlogToList(blog);
      });
    }
  });
}